import { useContext } from "react";
import { useHistory } from "react-router-dom";
import useNavigationUrl from "@common/hooks/useNavigationUrl";
import { useAssignmentProposalStore } from "@context/useAssignmentProposalStore";
import { AppContext } from "../context/EditSessionsContext";
import { useReturnToCurrentSchedule } from "./useReturnToCurrentSchedule";

/**
 * After a reviewer's decision the user leaves the editor for the page the proposal was opened from
 * or, without one (a direct link, a new tab), for the calendar of the link's first group. The
 * editor entry is replaced, so going back does not open the decided proposal again. A link without
 * groups keeps the user in the editor, on its current schedule.
 */
export const useLeaveDecidedProposal = () => {
  const history = useHistory();
  const { state } = useContext(AppContext);
  const { editorUrl } = useNavigationUrl();
  const returnTo = useAssignmentProposalStore(store => store.editorReturnTo);
  const returnToCurrentSchedule = useReturnToCurrentSchedule();
  const firstGroupId = state?.link?.info?.groups?.[0]?.id;

  return () => {
    const target = returnTo || (firstGroupId ? editorUrl("group", String(firstGroupId)) : null);

    if (target) history.replace(target);
    else returnToCurrentSchedule();
  };
};
